module.exports = __webpack_public_path__ + "static/media/poojaNeeds.0d0e99a0.webp";